module.exports = __webpack_public_path__ + "img/dispatching-mobile.c1d47a64.jpg";